<div role="alert" class="fw-600"
  [ngClass]="{'lead no-margin margin-top-10': !(viewportService?.viewport$ | async)?.isMobile}">
  {{message}}
</div>
